
import service from 'common/service';
import { getEnv } from 'common/utils';


export const useIMLogin = ({isManagementBackground}) => {
  const login = async () => {
    let res;
    if(isManagementBackground) {
      res = await service.backendUser.getUserImToken();
    }else {
      res = await service.userSetting.getUserImToken();
    }
    if (res && res.data) {
      const data = res.data;
      const iframe = document.getElementById('chatRoom') as HTMLIFrameElement;
      const { isInternal } = getEnv();
      if (iframe) {
        const message = JSON.stringify({
          type: 'login',
          data: { token: data.token, accid: data.accid, sessionType: isInternal ? 'INNER' : 'OUTER' },
        });
        iframe.contentWindow?.postMessage(message, '*');
      }
    }
  };
  return { login };
};
